module.exports = __webpack_public_path__ + "media/dashboard/assets/images/empty-contacts-5a0645e20f17a85fdd52e7061351626f.svg";